import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import Swal from 'sweetalert2'; // 🔥 ADD
import ServiceCard from '../../../../components/customer/services/servicecards/ServiceCards';
// import '../../../../assets/css/screens/customer/services/Services.css';
import LoginModal from '../../../../components/customer/auth/loginModal/LoginModal';

import axios from "axios";
import '../../../../assets/css/subscreens/customer/home/topservices/TopServices.css';
import AppContext from '../../../../context/AppContext';


const TopServices = () => {
const {baseUrl, baseUrlForFile} = useContext(AppContext);
  const [categories, setCategories] =useState([]);
   const navigate = useNavigate();

useEffect(() => {
  axios.get(`${baseUrl}/user/viewcategory`)
    .then((res) => {

      console.log("API RESPONSE:", res.data);

      const categoriesData = res.data.categories || [];

      const formatted = categoriesData.map((cat) => ({
        id: cat.id,
        name: cat.categoryName,        // ✅ FIXED
        description: cat.description,
      image: `${baseUrlForFile}/${cat.categoryImage}`
      }));

      setCategories(formatted);
    })
    .catch((err) => console.log(err));
}, [baseUrl, baseUrlForFile]);
const [showLoginModal, setShowLoginModal] = useState(false);
  // 🔥 LOGIN CHECK FUNCTION
  const handleServiceClick = (service) => {
  const isLoggedIn = localStorage.getItem("isLoggedIn");

  if (!isLoggedIn) {
    Swal.fire({
      icon: 'warning',
      title: 'Login Required',
      text: 'Please login first to access this service.',
      confirmButtonText: 'Login Now',
    }).then((result) => {
      if (result.isConfirmed) {
        setShowLoginModal(true);
      }
    });
    return;
  }

navigate(
  `/services/${service?.name?.toLowerCase()?.replace(/\s+/g, '-')}`
);
};

  return (
    <>
  
    <section className="nfys-section">

      {/* HEADER */}
      <div className="nfys-header">
        <h1 className="nfys-title">Our Services</h1>

        <button
          className="nfys-view-all"
          onClick={() => navigate('/services')}
        >
          View all <ArrowRight size={16} />
        </button>
      </div>

      {/* GRID */}
    <div className="nfys-grid">
 {categories?.map((cat, idx) => (
  <ServiceCard
  key={cat?.id}
  item={{
    name: cat?.name || "No Name",
    description: cat?.description || "No description",
    image: cat?.image
  }}
  index={idx}
onClick={() => handleServiceClick(cat)}
/>
))}
</div>

    </section>
    <LoginModal
  isOpen={showLoginModal}
  onClose={() => setShowLoginModal(false)}
  onLoginSuccess={() => {
    localStorage.setItem("isLoggedIn", "true"); // 🔥 IMPORTANT
    setShowLoginModal(false);
  }}
/>
  </>
  );
  
};

export default TopServices;